import store from "../store";
import router from "../router";
import ConsoleLogService from "../services/ConsoleLogService";

export default class Utils {
  static get log() {
    return (
      window.log || {
        info: function(...args) {
          console.info(
            "%cCustomChat: " + args,
            "background: #e0e2ff; color: #323333;"
          );
          var toLog = args;
          if (typeof args === "object" && args !== null)
            toLog = JSON.stringify(args);
          ConsoleLogService.addToCollectedLogs("info", [
            "CustomChat: " + toLog,
          ]);
        },
        error: function(...args) {
          console.error(
            "%cCustomChat: " + args,
            "background: #e0e2ff; color: red;"
          );
          var toLog = args;
          if (typeof args === "object" && args !== null)
            toLog = JSON.stringify(args);
          ConsoleLogService.addToCollectedLogs("error", [
            "CustomChat: " + toLog,
          ]);
        },
        warn: function(...args) {
          console.warn(
            "%cCustomChat: " + args,
            "background: #e0e2ff; color: #AA6800;"
          );
          var toLog = args;
          if (typeof args === "object" && args !== null)
            toLog = JSON.stringify(args);
          ConsoleLogService.addToCollectedLogs("warn", [
            "CustomChat: " + toLog,
          ]);
        },
        debug: function(...args) {
          console.debug(
            "%cCustomChat: " + args,
            "background: #e0e2ff; color: #323333;"
          );
          var toLog = args;
          if (typeof args === "object" && args !== null)
            toLog = JSON.stringify(args);
          ConsoleLogService.addToCollectedLogs("debug", [
            "CustomChat: " + toLog,
          ]);
        },
      }
    );
  }

  static setCurrentRoute(routeName){
    let routerArr = router.getRoutes();
    let route = routerArr.find(x=>x.name == routeName);
    router.currentRoute = route;
    router.push(routeName);
  }

  static getCurrentRouteName(){
    var currRoute = null;
    if (router.currentRoute)
      currRoute = router.currentRoute.name ?  router.currentRoute.name : router.currentRoute.value ?
      (router.currentRoute.value.name ? router.currentRoute.value.name : router.currentRoute.value.path ? router.currentRoute.value.path : router.currentRoute.value)
      : router.currentRoute.path ? router.currentRoute.path : null;
    if (currRoute) {
      if (typeof currRoute != 'string') currRoute = null;
      else currRoute = currRoute.replace(/[^a-zA-Z]/g, "");
    }
    return currRoute;
  }

  static findObJInArrByKeyValue(arr, key, val) {
    return arr.find((el) => el[key] === val);
  }

  static getUrlVars() {
    let vars = {};
    let parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function(m, key, value) {
        let k = key.toLowerCase();
        vars[k] = value;
      }
    );
    return vars;
  }

  static getCustomUrlVars(url) {
    let vars = {};
    let parts = url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
      let k = key.toLowerCase();
      vars[k] = value;
    });
    return vars;
  }

  static getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  //checkBoxHeader - who clicked
  //cb - who moved
  static initMoveDiv(cb, checkBoxHeader, allDirections) {
    let mousePosition;
    let offset = [0, 0];
    let isDown = false;

    if (cb && checkBoxHeader) {
      checkBoxHeader.addEventListener(
        "mousedown",
        (e) => {
          isDown = true;
          offset = [cb.offsetLeft - e.clientX];
          if (allDirections) {
            offset.push(cb.offsetTop - e.clientY);
          }
        },
        true
      );
    }
    document.addEventListener(
      "mouseup",
      () => {
        isDown = false;
      },
      true
    );  
    document.addEventListener(
      "mousemove",
      (event) => {
        event.preventDefault();
        if (isDown) {
          mousePosition = {
            x: event.clientX,
            y: event.clientY,
          };
          if (allDirections) {
            mousePosition["y"] = event.clientY;
          }
          if (cb) {
            cb.style.left = mousePosition.x + offset[0] + "px";
            if (allDirections) {
              cb.style.top = mousePosition.y + offset[1] + "px";
            }
          }
        }
      },
      true
    );
  }

  //When page reloaded, or about to close
  static initUnloadEventListener() {
    // Utils.log.debug(`on initUnloadEventListener..`);
    window.onbeforeunload = (event) => {
      if (store.getters.widgetData.config.isOnBeforeUnloadAlert) {
        Utils.log.debug(`on onbeforeunload..`);
        let e = event || window.event;
        // For IE and Firefox
        if (e) {
          e.returnValue = !store.getters.isConnect ? undefined : "";
        }
        // For Chrome and Safari
        return !store.getters.isConnect ? undefined : "";
      }
    };
    window.addEventListener("unload", () => {
      Utils.log.debug("on unload..");
      if (store.getters.isSCOverride) {
        Utils.log.debug("SC override enabled - leaveChat on unload");
        store.dispatch("leaveChat", { isAsync: false });
      } else if (!sessionStorage.getItem("cc_resumed")) {
        window.parent.postMessage("Contact disconnected by consumer", "*");      
        if (store.getters.widgetData.config.disconnectOnUnloadWhenNotResumed) {
          Utils.log.debug("Configured to leaveChat on unload when not resumed");
          store.dispatch("leaveChat", { isAsync: false });
        } else {
          Utils.log.debug("Configured to NOT leaveChat on unload - allows page refresh + resume");
        }
      } else {
        Utils.log.debug("Chat is resumed on another tab - not leaving chat on unload");
      }
    });
  }

  static clickOnPage(x, y) {
    var ev = document.createEvent("MouseEvent");
    var el = document.elementFromPoint(x, y);
    ev.initMouseEvent(
      "click",
      true /* bubble */,
      true /* cancelable */,
      window,
      null,
      x,
      y,
      0,
      0 /* coordinates */,
      false,
      false,
      false,
      false /* modifier keys */,
      0 /*left*/,
      null
    );
    el.dispatchEvent(ev);
  }

  static postMessage(msg) {
    window.parent.postMessage("CustomChat: " + msg, "*");
    Utils.log.debug("Posted message:" + msg);
  }

  static postMessageObject(type, object) {
    var toSend = { type: type, data: object };
    var asText = JSON.stringify(toSend);
    Utils.postMessage(asText, "*");
  }

  static isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }
  // static isChrome() {
  //   return (
  //     /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
  //   );
  // }

  static mobileCheck() {
    let check = false;
    (function(a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }
 
  static listenForMessages() {
    function messageHandler(event) {
      try {
        if (!event.data || !event.data.CC || !event.data.CC.type) return;
        Utils.log.debug("Received controller message:" + event.data.CC.type);
        if (event.data.CC.type == "startChat") {
          //store.dispatch("joinChat");
          store.commit("setConnectedToCallCenter", false);
          store.commit("setKioskIsClose", true);
          store.commit("initChatAndVideo");
          store.commit("resetConversationData");
          store.commit("setParticipantName","");
          store.commit("setCurrentView", "chat");
          store.commit("setAutoJoin", true);
          store.commit("setOptionalParameterFromExternal", event.data.CC.data.ops);
          store.commit("setDataBeforeJoinChat", {strFirstName:event.data.CC.data.user_id, strUserSubject:event.data.CC.data.summary});
          router.push("EnterView");
        }
        else if (event.data.CC.type == "endChat") {            
          store.dispatch("leaveChat", {isAsync: true});
          window.removeEventListener("message", messageHandler); // No further instruction from controller
        }
        else if (event.data.CC.type == "endChatCC") {
          window.removeEventListener("message", messageHandler); // No further instruction from controller
        }
        else if (event.data.CC.type == "messageToAgent") {          
          store.commit("setDataBeforeSendMessage", event.data.CC.data);
          store.dispatch("sendMessage");
        }
        else if (event.data.CC.type == "userTyping") {
          store.dispatch("setTypingStatus", event.data.CC.data ? 1 : 2);
        }
  
      } catch(e){}
    }
  
    window.addEventListener("message", messageHandler);
  }

  // START SC Proxy and Connection to prevent persistant store failure 
  static setSCProxy(proxy) {
    if (!window.cc_sc) window.cc_sc = {};
    window.cc_sc.scProxy = proxy;
  }    
  static setSCConnection(connection) {
    if (!window.cc_sc) window.cc_sc = {};
    window.cc_sc.scConnection = connection;
  };
    
  static getSCProxy() {
    if (!window.cc_sc) return null;
    return window.cc_sc.scProxy;
  }

  static getSCConnection(connection) {
    if (!window.cc_sc) return null;
    return window.cc_sc.scConnection;
  };
// END SC Proxy and Connection to prevent persistant store failure     
}
